/**
 * 이력서 서비스 → 브이매치 전환 안내 배너.
 *
 * 전환이 완료되어 이력서 등록·조회 기능은 모두 중단됐다. 상세 안내는 정적 페이지
 * /transfer 가 담당하며, React Router 밖 경로라 <a> 로 전체 이동시킨다.
 */

import { transferNoticeUrl } from '../../utils/transferNotice';

/** 정적 안내 페이지 — React Router 밖의 경로라 <a>로 전체 이동시킨다. */
const TRANSFER_NOTICE_PATH = transferNoticeUrl('resume-home');

const actionClass =
  'inline-flex w-full flex-shrink-0 items-center justify-center rounded-lg border border-[#16C1B1] ' +
  'bg-white px-4 py-2 text-[13px] font-[700] text-[#0F8F84] hover:bg-[#E8F8F6] ' +
  'md:w-auto md:whitespace-nowrap md:px-5 md:text-[14px]';

const ResumeTransitionNotice = ({ className = '' }) => (
  <div
    className={`w-full max-w-[1124px] overflow-hidden break-keep rounded-xl border border-[#BFE9E4] bg-[#F4FBFA] text-[#111827] shadow-[0_4px_14px_rgba(15,23,42,0.05)] ${className}`}
    role="region"
    aria-label="이력서 서비스 전환 안내"
  >
    <div className="flex flex-col gap-3 px-4 py-3 md:flex-row md:items-center md:gap-4 md:px-5 md:py-4">
      <div className="flex min-w-0 flex-1 items-start gap-2.5 md:gap-3">
        <span
          className="mt-0.5 inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#16C1B1] text-[12px] font-[700] text-white"
          aria-hidden="true"
        >
          !
        </span>
        <div className="min-w-0">
          <p className="text-[13px] font-[700] leading-6 md:text-[15px]">
            이력서 서비스가 브이매치로 변경되었습니다.
          </p>
          <p className="mt-0.5 text-[12px] leading-5 text-[#4B5563] md:text-[13px]">
            구직자분들께 더 편리한 구직 환경을 제공하기 위해 브이매치로 새롭게 시작합니다. 기존 이력서의 이전 방법과
            삭제 요청 절차를 안내해 드립니다.
          </p>
        </div>
      </div>

      <a href={TRANSFER_NOTICE_PATH} className={actionClass}>
        안내 확인하기
      </a>
    </div>
  </div>
);

export default ResumeTransitionNotice;
